export default "__VITE_ASSET__CtL1FIzQ__"